import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard } from "../App";
import { RoleGuard } from "../App";
import { StandardURL } from "../App";

const CaretakersPage = () => {
  const [caretakers, setCaretakers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const propertyId = localStorage.getItem("selectedPropertyId");
    axios
      .get(
        `${StandardURL}/iNyumba/users/${propertyId}/caretaker`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setCaretakers(response.data.response);
      })
      .catch((error) => {
        console.error("Error fetching caretakers:", error);
      });
  }, []);

  const handleAddButtonClick = () => {
    navigate("/landlord/registercaretaker");
  };

  const handleDeleteButtonClick = (caretaker) => {
    // Code to set the specific caretaker uuid and navigate to delete page
    localStorage.setItem("selectedCaretakerId", caretaker.uuid);
    navigate("/landlord/deletecaretaker");
  };

 return (
  <RoleGuard>
    <AuthGuard>
      <div className="min-h-screen bg-gray-100 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto"> 
          <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-8 text-center leading-tight">
            Your Caretakers <span role="img" aria-label="people">👥</span>
          </h1>

          <div className="flex justify-end mb-6"> 
            <button
              onClick={handleAddButtonClick}
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-200 ease-in-out transform hover:-translate-y-0.5"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="-ml-1 mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM12 15v3m0 0v3m0-3h3m-3 0H9m12-9A6 6 0 0012 3C6.477 3 2 7.477 2 13s4.477 10 10 10 10-4.477 10-10V9z" />
              </svg>
              Add Caretaker
            </button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {caretakers.length === 0 ? (
              <p className="col-span-full text-center text-gray-600 text-lg py-10 bg-white rounded-lg shadow-md border border-gray-200">
                No caretakers registered yet. Click "Add Caretaker" to get started!
              </p>
            ) : (
              caretakers.map((caretaker) => (
                <div
                  key={caretaker.id}
                  className="bg-white shadow-lg hover:shadow-xl rounded-xl p-6 border border-gray-200 flex flex-col justify-between transform hover:scale-102 transition-all duration-300 ease-in-out"
                >
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-2 leading-snug">{caretaker.name}</h2>
                    <p className="text-gray-700 text-sm mb-1"><span className="font-medium">Email:</span> {caretaker.email}</p>
                    <p className="text-gray-700 text-sm mb-1"><span className="font-medium">Phone:</span> {caretaker.phone}</p>
                    <p className="text-gray-700 text-sm mb-3"><span className="font-medium">Role:</span> {caretaker.role}</p>
                  </div>

                  <div className="mt-4 flex items-center justify-between">
                    {/* Status Badge */}
                    <span className={`px-3 py-1 text-xs font-semibold rounded-full ${
                      caretaker.status === 'Verified'
                        ? 'bg-green-100 text-green-800'
                        : caretaker.status === 'Pending'
                        ? 'bg-yellow-100 text-yellow-800'
                        : 'bg-red-100 text-red-800' // Default or other statuses
                    }`}>
                      {caretaker.status}
                    </span>

                    {/* Delete Button */}
                    <button
                      onClick={() => handleDeleteButtonClick(caretaker)}
                      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition duration-200 ease-in-out transform hover:-translate-y-0.5"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="-ml-0.5 mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                      Delete
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </AuthGuard>
  </RoleGuard>
);
};

export default CaretakersPage;
